import { type FC, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { GetNotificationSettingsDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import BookkeepersSettings from 'modules/bookkeepers/components/NotificationsSettings'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { GeneralSettings } from 'modules/notifications/components/Preferences/GeneralSettings'
import { PreferencesSearchBar } from 'modules/notifications/components/Preferences/PreferencesSearchBar'
import { UserPreferences } from 'modules/notifications/components/Preferences/UserPreferences'

const NotificationsSettings: FC = () => {
  const {
    access: { id: accessId },
  } = useCurrentSession()
  const {
    data,
    loading: loadingGetNotificationSettings,
    error,
  } = useQuery(GetNotificationSettingsDocument, {
    variables: {
      accessId: accessId,
    },
  })
  const [search, setSearch] = useState('')
  const settings = data?.notifications?.accessNotificationSettingsConnection?.edges?.[0]?.node

  const loading = !data && loadingGetNotificationSettings

  return (
    <ResponsivePage.Body variant="narrow" loading={loading} error={error} showHeader={false}>
      <Box width="narrowPage">
        <Box paddingY="s32">
          <PreferencesSearchBar
            search={search}
            onSearch={setSearch}
            disabled={settings?.disableAll}
          />
        </Box>
        {!search.length && (
          <>
            <BookkeepersSettings
              canManagePayrollIncidences={
                data?.payroll._policies.managePayrollIncidences.can ?? false
              }
            />
            <GeneralSettings settings={settings} />
          </>
        )}
        {settings?.disableAll ? null : <UserPreferences search={search} />}
      </Box>
    </ResponsivePage.Body>
  )
}

export default observer(NotificationsSettings)
